import {BitrixVue} from 'ui.vue'
import './resultBlockItem.js'

BitrixVue.component('ResultBlock', {
  props: ['basket', 'totalAmount'],
  template: `
    <div class="result-block">
        <h2 class="config-title">Комплектация заказа</h2>

        <div class="result-block__wrap">
            <div class="result-block__inner">
                <ResultBlockItem v-for="(item, index) in basket" :data="item" :number="index"/>
            </div>
        </div>

    </div>
`,
})
